
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("jEppW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ChoreographerRegistry", () => $c08b89b641348d3e$export$651e1f902bdd710b);
$parcel$export(module.exports, "default", () => $c08b89b641348d3e$export$2e2bcd8739ae039);

var $gnNAD = parcelRequire("gnNAD");
var $jabQz = parcelRequire("jabQz");

var $3cYHF = parcelRequire("3cYHF");
const $c08b89b641348d3e$var$mapEnvToAnalyticsEnv = (env)=>{
    switch(env){
        case 'test':
        case 'local':
            return (0, $3cYHF.envType).LOCAL;
        case 'dev':
            return (0, $3cYHF.envType).DEV;
        case 'staging':
        case 'stg-fedm-east':
            return (0, $3cYHF.envType).STAGING;
        case 'production':
        case 'prod-fedm-east':
            return (0, $3cYHF.envType).PROD;
        default:
            return (0, $3cYHF.envType).DEV;
    }
};
class $c08b89b641348d3e$export$651e1f902bdd710b {
    constructor(product, environment){
        this.product = product;
        this.environment = environment;
    }
    getPostOfficeChoreographerFactory() {
        if (globalThis.window.choreographerRegistry === undefined) globalThis.window.choreographerRegistry = new Map();
        const maybeChoreographerFactory = globalThis.window.choreographerRegistry.get((0, $jabQz.ProductIds).POST_OFFICE);
        if (maybeChoreographerFactory) return maybeChoreographerFactory;
        const factory = (0, $gnNAD.choreographerFactory)((0, $jabQz.ProductIds).POST_OFFICE, $c08b89b641348d3e$var$mapEnvToAnalyticsEnv(this.environment), {
            sourceProductId: this.product
        });
        globalThis.window.choreographerRegistry.set((0, $jabQz.ProductIds).POST_OFFICE, factory);
        return factory;
    }
}
var $c08b89b641348d3e$export$2e2bcd8739ae039 = $c08b89b641348d3e$export$651e1f902bdd710b;

});


//# sourceMappingURL=choreographerRegistry.e33ca8a1.js.map
